import { Chip } from '@mui/material'

/**
 * A background job's state — template generation, safety-stock calculation —
 * as a labelled chip (design system: Chip). The grids drew these as icons
 * whose meaning lived in a tooltip, and for "unstarted" nowhere at all.
 */
export const RunStatusChip = ({ status }: { status?: string | null }) => {
  switch (status) {
    case 'completed':
      return <Chip label="Complete" color="success" />
    case 'initiated':
    case 'processing':
    case 'running':
      return <Chip label="Processing" color="warning" />
    case 'failed':
      return <Chip label="Failed" color="error" />
    default:
      return <Chip label="Not started" color="default" />
  }
}
